import {Repository} from '@s-ui/domain'

/**
 * @interface
 */
export default class CheckoutRepository extends Repository {
  getPaymentMethods() {
    throw new Error('[CheckoutRepository#getPaymentMethods] must be implemented')
  }

  createOrder() {
    throw new Error('[CheckoutRepository#createOrder] must be implemented')
  }

  purchase() {
    throw new Error('[CheckoutRepository#purchase] must be implemented')
  }

  getPurchaseDetails() {
    throw new Error('[CheckoutRepository#getPurchaseDetails] must be implemented')
  }
}
